<template>

    <svg
        v-if="variant === 'FIRST'"
        :width="scaledSize.width"
        :height="scaledSize.height"
        :viewBox="scaledSize.viewBox"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        :aria-label="`Step ${step}`"
    >
        <g filter="url(#stepDropShadow)" transform="translate(-11,-11)">
            <mask :id="maskId" fill="white">
                <path
                    d="M183.292 11C184.927 11 186.398 11.9958 187.006 13.5144L201.406 49.5144C201.787 50.4681 201.787 51.5319 201.406 52.4856L187.006 88.4856C186.398 90.0042 184.927 91 183.292 91H17C13.6863 91 11 88.3137 11 85V17C11 13.6863 13.6863 11 17 11H183.292Z"
                />
            </mask>

            <!-- 채움 -->
            <path
                d="M183.292 11C184.927 11 186.398 11.9958 187.006 13.5144L201.406 49.5144C201.787 50.4681 201.787 51.5319 201.406 52.4856L187.006 88.4856C186.398 90.0042 184.927 91 183.292 91H17C13.6863 91 11 88.3137 11 85V17C11 13.6863 13.6863 11 17 11H183.292Z"
                fill="white"
            />

            <!-- 테두리 -->
            <path
                d="M17 91L17 93H17V91ZM11 17L9 17V17H11ZM187.006 88.4856L185.149 87.7428L187.006 88.4856ZM201.406 49.5144L203.263 48.7717L201.406 49.5144ZM201.406 52.4856L203.263 53.2283L201.406 52.4856ZM187.006 13.5144L185.149 14.2572L187.006 13.5144ZM187.006 13.5144L185.149 14.2572L199.549 50.2572L201.406 49.5144L203.263 48.7717L188.863 12.7717L187.006 13.5144ZM201.406 52.4856L199.549 51.7428L185.149 87.7428L187.006 88.4856L188.863 89.2283L203.263 53.2283L201.406 52.4856ZM183.292 91V89H17V91V93H183.292V91ZM17 91L17 89C14.7909 89 13 87.2091 13 85H11H9C9 89.4183 12.5817 93 17 93L17 91ZM11 85H13V17H11H9V85H11ZM11 17L13 17C13 14.7909 14.7909 13 17 13V11V9C12.5817 9 9.00004 12.5818 9 17L11 17ZM17 11V13H183.292V11V9H17V11ZM187.006 88.4856L185.149 87.7428C184.845 88.5021 184.11 89 183.292 89V91V93C185.745 93 187.952 91.5063 188.863 89.2283L187.006 88.4856ZM201.406 49.5144L199.549 50.2572C199.74 50.734 199.74 51.266 199.549 51.7428L201.406 52.4856L203.263 53.2283C203.835 51.7979 203.835 50.2021 203.263 48.7717L201.406 49.5144ZM187.006 13.5144L188.863 12.7717C187.952 10.4937 185.745 9 183.292 9V11V13C184.11 13 184.845 13.4979 185.149 14.2572L187.006 13.5144Z"
                :fill="config.borderColor"
                :mask="`url(#${maskId})`"
            />

            <!-- 콘텐츠 -->
            <foreignObject x="20" y="20" width="170" height="60">
                <div
                    xmlns="http://www.w3.org/1999/xhtml"
                    class="flex flex-col justify-center items-start pl-7 w-full h-full"
                >
                    <div
                        class="flex gap-1 text-center items-center font-inter-caption-1"
                    >
                        <CheckCircleIcon :color="config.iconColor" weight="FILL" />
                        <span :class="config.stepColor">{{ `Step ${step}` }}</span>
                    </div>
                    <div v-html="title" class="font-inter-caption-1" :class="config.textColor"></div>
                </div>
            </foreignObject>
        </g>
    </svg>

    <!-- LAST -->
    <svg
        v-else-if="variant === 'LAST'"
        :width="scaledSize.width"
        :height="scaledSize.height"
        :viewBox="scaledSize.viewBox"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        :aria-label="`Step ${step}`"
    >
        <g filter="url(#stepDropShadow)" transform="translate(-12.1942,0)">
            <mask :id="maskId" fill="white">
                <path
                    d="M179 11C182.314 11 185 13.6863 185 17V85C185 88.3137 182.314 91 179 91H15.9081C13.0783 91 11.1432 88.1419 12.1942 85.5144L25.4058 52.4856C25.7872 51.5319 25.7872 50.4681 25.4058 49.5144L12.1942 16.4856C11.1432 13.8581 13.0783 11 15.9081 11H179Z"
                />
            </mask>

            <path
                d="M179 11C182.314 11 185 13.6863 185 17V85C185 88.3137 182.314 91 179 91H15.9081C13.0783 91 11.1432 88.1419 12.1942 85.5144L25.4058 52.4856C25.7872 51.5319 25.7872 50.4681 25.4058 49.5144L12.1942 16.4856C11.1432 13.8581 13.0783 11 15.9081 11H179Z"
                fill="white"
            />

            <path
                d="M25.4058 52.4856L24.1059 51.9656L25.4058 52.4856ZM25.4058 49.5144L24.1059 50.0344L25.4058 49.5144ZM12.1942 85.5144L10.8944 84.9945L12.1942 85.5144ZM179 11V12.4C181.541 12.4 183.6 14.4595 183.6 17H185H186.4C186.4 12.9131 183.087 9.6 179 9.6V11ZM185 17H183.6V85H185H186.4V17H185ZM185 85H183.6C183.6 87.5405 181.541 89.6 179 89.6V91V92.4C183.087 92.4 186.4 89.0869 186.4 85H185ZM179 91V89.6H15.9081V91V92.4H179V91ZM12.1942 85.5144L13.4941 86.0344L26.7056 53.0055L25.4058 52.4856L24.1059 51.9656L10.8944 84.9945L12.1942 85.5144ZM25.4058 49.5144L26.7056 48.9945L13.4941 15.9656L12.1942 16.4856L10.8944 17.0055L24.1059 50.0344L25.4058 49.5144ZM15.9081 11V12.4H179V11V9.6H15.9081V11ZM12.1942 16.4856L13.4941 15.9656C12.811 14.2578 14.0687 12.4 15.9081 12.4V11V9.6C12.0878 9.6 9.47553 13.4584 10.8944 17.0055L12.1942 16.4856ZM25.4058 52.4856L26.7056 53.0055C27.2206 51.7181 27.2206 50.2819 26.7056 48.9945L25.4058 49.5144L24.1059 50.0344C24.3539 50.6543 24.3539 51.3457 24.1059 51.9656L25.4058 52.4856ZM15.9081 91V89.6C14.0687 89.6 12.811 87.7422 13.4941 86.0344L12.1942 85.5144L10.8944 84.9945C9.47553 88.5415 12.0878 92.4 15.9081 92.4V91Z"
                :fill="config.borderColor"
                :mask="`url(#${maskId})`"
            />

            <foreignObject x="20" y="20" width="170" height="60">
                <div
                    xmlns="http://www.w3.org/1999/xhtml"
                    class="flex flex-col justify-center items-start pl-7 w-full h-full"
                >
                    <div
                        class="flex gap-1 text-center items-center font-inter-caption-1"
                    >
                        <CheckCircleIcon :color="config.iconColor" weight="FILL" />
                        <span :class="config.stepColor">{{ `Step ${step}` }}</span>
                    </div>
                    <div v-html="title" class="font-inter-caption-1" :class="config.textColor"></div>
                </div>
            </foreignObject>
        </g>
    </svg>

    <!-- MIDDLE -->
    <svg
        v-else
        :width="scaledSize.width"
        :height="scaledSize.height"
        :viewBox="scaledSize.viewBox"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        :aria-label="`Step ${step}`"
    >
        <g filter="url(#stepDropShadow)" transform="translate(-12.1943,-11)">
            <mask :id="maskId" fill="white">
                <path
                    d="M182.292 11C183.927 11 185.398 11.9958 186.006 13.5144L200.406 49.5144C200.787 50.4681 200.787 51.5319 200.406 52.4856L186.006 88.4856C185.398 90.0042 183.927 91 182.292 91H15.9082C13.0783 91 11.1433 88.1419 12.1943 85.5144L25.4062 52.4854C25.7875 51.5319 25.7875 50.4681 25.4062 49.5146L12.1943 16.4856C11.1433 13.8581 13.0783 11 15.9082 11H182.292Z"
                />
            </mask>

            <path
                d="M182.292 11C183.927 11 185.398 11.9958 186.006 13.5144L200.406 49.5144C200.787 50.4681 200.787 51.5319 200.406 52.4856L186.006 88.4856C185.398 90.0042 183.927 91 182.292 91H15.9082C13.0783 91 11.1433 88.1419 12.1943 85.5144L25.4062 52.4854C25.7875 51.5319 25.7875 50.4681 25.4062 49.5146L12.1943 16.4856C11.1433 13.8581 13.0783 11 15.9082 11H182.292Z"
                fill="white"
            />

            <path
                d="M25.4062 52.4854L26.7061 53.0053L26.7062 53.0052L25.4062 52.4854ZM25.4062 49.5146L26.7062 48.9948L26.7061 48.9947L25.4062 49.5146ZM12.1943 85.5144L10.8944 84.9944L12.1943 85.5144ZM186.006 88.4856L184.706 87.9656L186.006 88.4856ZM200.406 49.5144L201.706 48.9945L200.406 49.5144ZM200.406 52.4856L201.706 53.0055L200.406 52.4856ZM186.006 13.5144L184.706 14.0344L186.006 13.5144ZM186.006 13.5144L184.706 14.0344L199.106 50.0344L200.406 49.5144L201.706 48.9945L187.306 12.9945L186.006 13.5144ZM200.406 52.4856L199.106 51.9656L184.706 87.9656L186.006 88.4856L187.306 89.0055L201.706 53.0055L200.406 52.4856ZM182.292 91V89.6H15.9082V91V92.4H182.292V91ZM12.1943 85.5144L13.4942 86.0344L26.7061 53.0053L25.4062 52.4854L24.1064 51.9654L10.8944 84.9944L12.1943 85.5144ZM25.4062 52.4854L26.7062 53.0052C27.2209 51.718 27.2209 50.282 26.7062 48.9948L25.4062 49.5146L24.1063 50.0345C24.3542 50.6542 24.3542 51.3458 24.1063 51.9655L25.4062 52.4854ZM25.4062 49.5146L26.7061 48.9947L13.4942 15.9656L12.1943 16.4856L10.8944 17.0056L24.1064 50.0346L25.4062 49.5146ZM15.9082 11V12.4H182.292V11V9.6H15.9082V11ZM15.9082 91V89.6C14.0688 89.6 12.811 87.7422 13.4942 86.0344L12.1943 85.5144L10.8944 84.9944C9.47556 88.5415 12.0879 92.4 15.9082 92.4V91ZM186.006 88.4856L184.706 87.9656C184.311 88.9527 183.355 89.6 182.292 89.6V91V92.4C184.5 92.4 186.486 91.0557 187.306 89.0055L186.006 88.4856ZM12.1943 16.4856L13.4942 15.9656C12.811 14.2578 14.0688 12.4 15.9082 12.4V11V9.6C12.0879 9.6 9.47557 13.4585 10.8944 17.0056L12.1943 16.4856ZM200.406 49.5144L199.106 50.0344C199.354 50.6543 199.354 51.3457 199.106 51.9656L200.406 52.4856L201.706 53.0055C202.221 51.7181 202.221 50.2819 201.706 48.9945L200.406 49.5144ZM186.006 13.5144L187.306 12.9945C186.486 10.9443 184.5 9.6 182.292 9.6V11V12.4C183.355 12.4 184.311 13.0473 184.706 14.0344L186.006 13.5144Z"
                :fill="config.borderColor"
                :mask="`url(#${maskId})`"
            />

            <foreignObject x="20" y="20" width="170" height="60">
                <div
                    xmlns="http://www.w3.org/1999/xhtml"
                    class="flex flex-col justify-center items-start pl-7 w-full h-full"
                >
                    <div
                        class="flex gap-1 text-center items-center font-inter-caption-1"
                    >
                        <CheckCircleIcon :color="config.iconColor" weight="FILL" />
                        <span :class="config.stepColor">{{ `Step ${step}` }}</span>
                    </div>
                    <div v-html="title" class="font-inter-caption-1" :class="config.textColor"></div>
                </div>
            </foreignObject>
        </g>
    </svg>
</template>

<script>
import CheckCircleIcon from './icon/check-circle.vue';

export default {
    components: {
        CheckCircleIcon,
    },
    name: 'StepSegment',
    props: {
        variant: { type: String, required: true }, // 'FIRST' | 'MIDDLE' | 'LAST'
        step: { type: Number, required: true },
        title: { type: String, default: '' },
        activeStatus : { type : String, default : 'NEXT' }, // ONGOING | COMPLETE | NEXT
        scaleX: { type: Number, default: 1 },
        scaleY: { type: Number, default: 1 },
    },
    data() {
        return {
            statusMap: {
                COMPLETE : {
                    borderColor : "#D1D3D8",
                    iconColor : "text-accent-blue-3",
                    textColor : "text-accent-blue-3",
                    stepColor : "text-accent-blue-3"
                },
                ONGOING : {
                    borderColor : "#4361EE",
                    iconColor : "text-background-inverse-4",
                    textColor : "text-primary-4",
                    stepColor : "text-transparent-basic-3"
                },
                NEXT : {
                    borderColor : "#D1D3D8",
                    iconColor : "text-background-inverse-4",
                    textColor : "text-transparent-basic-3",
                    stepColor : "text-transparent-basic-3"
                },
            },
        };
    },
    computed: {
        maskId() {
            // 마스크 id 충돌 방지: 컴포넌트 uid 기반
            // Vue 3에선 this._.uid 가 내부에 있으므로 아래처럼 고유 스트링 생성
            const uid = this._.uid || Math.floor(Math.random() * 1e9);
            return `step-mask-${this.variant}-${uid}`;
        },
        config() {
            return this.statusMap[this.activeStatus] || null;
        },
        scaledSize() {
            const base = {
                FIRST: { width: 191, height: 80, viewBox: '0 0 191 80' },
                MIDDLE: { width: 188.212, height: 80, viewBox: '0 0 188.212 80' },
                LAST: { width: 196, height: 102, viewBox: '0 0 196 102' },
            };
            const size = base[this.variant] || base.MIDDLE;
            return {
                width: size.width * this.scaleX,
                height: size.height * this.scaleY,
                viewBox: size.viewBox,
            };
        },
    },
};
</script>
